<!-- @format -->

<index-tag>
    <div class="container_breadcrumb">
        <ul class="breadcrumb">
            <li class="breadcrumb-item">
                <h1 class="heading-01 heading_home">ホーム</h1>
            </li>
        </ul>
    </div>
    <!--/.container_breadcrumb-->

    <div class="contents">
        <ul
                class="alert_message01 margin-spacing-1_bottom"
                if="{!state.pubinfoFilled}"
        >
            <li class="alert_message01-item">
                <a href="/menu/public-info">公開情報が未入力です</a>
            </li>
        </ul>
        <!--/.alert_message-->
        <ul
                class="alert_message01 margin-spacing-1_bottom"
                if="{!state.basicinfoFilled}"
        >
            <li class="alert_message01-item">
                <a href="/info">
                    本人確認書類が未提出です（お仕事の受託やクライアント様との交渉ができません）
                </a>
            </li>
        </ul>
        <!--/.alert_message-->

        <ul
                class="alert_message01 margin-spacing-4_bottom"
                if="{ state.alerts.length > 0}"
        >
            <li class="alert_message01-item" each="{item in state.alerts}">
                <a href="{item.link}">{item.message}(最終更新:{item.checked_at})</a>
                <button
                        class="ui right floated icon button"
                        onclick="{(e)=>recheck(e,item.type_id)}"
                >
                    <i class="sync icon"></i>
                </button>
            </li>
        </ul>
        <!--/.alert_message-->

        <section class="contents_area margin-spacing-4_bottom">
            <div class="contents_block">
                <div class="container_heading">
                    <h2 class="heading-02 heading_news">お知らせ</h2>
                    <div class="button_link">
                        <a href="/menu/information">全て見る</a>
                    </div>
                </div>
                <!--/.container_heading-->
                <ul class="table_list" if="{state.informations.length > 0}">
                    <li class="table_list-item" each="{info in state.informations}">
                        <span class="date">{info.created_at}</span>
                        <span class="label {informationLabel(info.service)}"></span>
                        <a href="/menu/information/{info.id}">{info.title}</a>
                    </li>
                </ul>
                <div class="empty" if="{state.informations.length === 0}">
                    <p class="empty-message">お知らせはありません。</p>
                </div>
            </div>
            <!--/.contents_block-->
        </section>
        <!--/.contents_area-->

        <section class="contents_area">
            <div class="contents_block">
                <div class="container_heading">
                    <h2 class="heading-02 heading_projects">稼働プロジェクト</h2>
                    <div class="button_link"><a href="/project">全て見る</a></div>
                </div>
                <!--/.container_heading-->
                <table class="contents_table margin-spacing-3_top">
                    <tbody>
                    <tr>
                        <th class="contents_table-cell_id">プロジェクトID</th>
                        <th class="contents_table-cell_title" style="width: 30%">プロジェクト</th>
                        <th class="contents_table-cell_price">金額（税込）</th>
                        <th class="contents_table-cell_schedule">希望納期</th>

                        <th class="" style="width: 15%">プロジェクトへの受諾</th>
                        <th class="" style="width: 15%">合意返信期限</th>

                        <th class="contents_table-cell_status">ステータス</th>

                    </tr>

                    <tr each="{project in state.activeProjects}">
                        <td class="contents_table-cell_id">{project.project_id}</td>
                        <td class="contents_table-cell_title">
                            <a href="/project/detail/{project.project_id}">
                                {project.title}
                            </a>
                        </td>
                        <td class="contents_table-cell_price">
                            <number-format
                                    number="{project.sub_amount+project.tax}"
                            ></number-format>
                            円
                        </td>
                        <td class="contents_table-cell_schedule">
                            {project.delivery_hope_date}
                        </td>

                        <td style="">
                            <span if="{(project.latest_nego_state === 0)}" style="color:#a9313f;">無効</span>
                            <span if="{(project.latest_nego_state === 100)}"
                                  style="color: #dca31e;font-weight: bold">未回答</span>
                            <span if="{(project.latest_nego_state === 200)}" style="color:#a9313f;">辞退</span>
                            <span if="{(project.latest_nego_state === 201)}"
                                  style="color:#a9313f;">辞退（返信期限切れ）</span>
                            <span if="{(project.latest_nego_state === 300)}" style="color:#a9313f;">決裂</span>
                            <span if="{(project.latest_nego_state === 301)}" style="color:#a9313f;">決裂</span>
                            <span if="{(project.latest_nego_state === 400)}" style="color: #107c58">受諾</span>
                        </td>
                        <td>
                <span if="{(project.latest_nego_state === 100)}">
                  {project.latest_nego_expire_time}
                </span>
                            <span if="{(project.latest_nego_state !== 100)}">
                  ---
                </span>
                        </td>

                        <td class="contents_table-cell_status">
                <span
                        class="status_label project_status_label-{project.state}"
                ></span>
                        </td>


                    </tr>
                    </tbody>
                </table>
                <!--/.contents_table-->
            </div>
            <!--/.contents_block-->
        </section>
        <!--/.contents_area-->

        <section class="contents_area">
            <div class="picup_block margin-spacing-3_top">
                <h2 class="heading-02 heading_normal margin-spacing-1_bottom">
                    注目の公募案件
                </h2>
                <div
                        is="pickup-slider"
                        featured-ads="{ state.featuredAds }"
                        detail="{ detail }"
                ></div>
            </div>
            <!--/.picup_block-->
        </section>
        <!--/.contents_area-->
    </div>
    <!--/.contents-->

    <public-info-navi-modal
            is-open="{ state.naviModalIsOpen }"
            on-close="{ e => update({naviModalIsOpen: false}) }"
    ></public-info-navi-modal>
    <agreement-modal
            is-open="{ state.agreementModalIsOpen }"
            on-close="{ onAgreementModalClose }"
            on-agree="{ onAgree }"
    ></agreement-modal>
    <invoice-provider-modal
            is-open="{ state.invoiceProviderModalIsOpen }"
            on-close="{ onInvoiceProviderModalClose }"
    ></invoice-provider-modal>

    <script>
        import di from "dependency-injection";
        import qs from "qs";
        import InformationLabel from "@model/information-label.js";
        import pickupslider from "@tags/parts/pickup-slider.riot";
        import publicInfoNaviModal from "@tags/modal/menu/public-info-navi-modal.riot";
        import agreementModal from "@tags/modal/menu/agreement-modal.riot";
        import invoiceProviderModal from "@tags/modal/menu/invoice-provider-modal.riot";

        export default {
            components: {
                "pickup-slider": pickupslider,
                "public-info-navi-modal": publicInfoNaviModal,
                "agreement-modal": agreementModal,
                "invoice-provider-modal": invoiceProviderModal,
            },
            informationLabel: InformationLabel.get,
            state: {
                pubinfoFilled: true,
                basicinfoFilled: true,
                informations: [],
                alerts: [],
                activeProjects: [],
                featuredAds: [],
                naviModalIsOpen: false,
                agreementModalIsOpen: false,
                invoiceProviderModalIsOpen: false,
            },
            detail(e, ad_id) {
                di.router.push(`/ad/detail/${ad_id}`);
            },
            recheck(e, type_id) {
                this.api
                    .request("index", "recheck-alert", {type: type_id})
                    .then((result) => {
                        if (!result) alert("まだ解消していません");
                        else this.fetchAlert();
                    });
            },
            fetchInvoiceProviderExpired() {
                this.api
                    .request("index", "invoice-provider-expired")
                    .then((data) =>
                        this.update({invoiceProviderExpired: data})
                    );
            },
            onAgree() {
                this.api
                    .request("index", "send-agreement")
                    .then((data) => this.onAgreementModalClose());
            },
            onAgreementModalClose() {
                this.update({agreementModalIsOpen: false});
            },
            onAgreementFetched(agreed) {
                if (!agreed) {
                    this.update({agreementModalIsOpen: true});
                }
            },
            fetchAgreement() {
                this.api
                    .request("index", "fetch-agreement")
                    .then(
                        (data) => {
                            this.onAgreementFetched(data)
                        }
                    );
            },
            onInvoiceProviderModalClose(checkedOk) {
                if (!checkedOk) {
                    this.update({invoiceProviderModalIsOpen: false});
                }
            },
            onInvoiceProviderChecked(state_ok) {
                if (!state_ok) {
                    this.update({invoiceProviderModalIsOpen: true});
                }
            },
            checkInvoiceProvider() {
                this.api
                    .request("index", "check-invoice-provider-state")
                    .then(
                        (data) => {
                            this.onInvoiceProviderChecked(data)
                        }
                    ).catch((e) => {
                    alert("エラーが発生しました。")
                })
            },
            onAlertsFetched(data) {
                this.update({alerts: data});
            },
            onActiveProjectsFetched(data) {
                this.update({activeProjects: data});
            },
            onFeaturedAdsFetched(data) {
                this.update({featuredAds: data});
            },
            onInformationFetched(data) {
                this.update({informations: data.items});
            },
            fetchActiveProjects() {
                this.api
                    .request("index", "active-projects")
                    .then((data) => this.onActiveProjectsFetched(data));
            },
            fetchFeaturedAds() {
                di.createApi("ad")
                    .request("index", "fetch-ads", {type: "featured"})
                    .then((data) => this.onFeaturedAdsFetched(data.items));
            },
            fetchAlerts() {
                this.api
                    .request("index", "alerts")
                    .then((data) => this.onAlertsFetched(data));
            },
            fetchInformations() {
                this.api
                    .request("information", "fetch", {limit: 5})
                    .then((data) => this.onInformationFetched(data));
            },
            fetchPubinfoFilled() {
                this.api
                    .request("index", "check-public-info-filled")
                    .then((data) => this.update({pubinfoFilled: data}));
            },

            fetchBasicinfoFilled() {
                this.api
                    .request("index", "check-basic-info-filled")
                    .then((data) => this.update({basicinfoFilled: data}));
            },
            /**
             * メニューエリアのマウント前の処理。
             * 全画面共通で実施するAPI（利用規約更新確認など）はここ
             */
            onBeforeMount() {
                this.api = di.createApi("menu");

                this.fetchAlerts();
                this.fetchActiveProjects();
                this.fetchFeaturedAds();
                this.fetchInformations();
                this.fetchPubinfoFilled();
                this.fetchBasicinfoFilled();
                this.fetchAgreement();
                this.checkInvoiceProvider()
            },
            onMounted() {
                const q = qs.parse(location.search.slice(1));
                switch (q.modal) {
                    case "public-info-navi":
                        this.update({naviModalIsOpen: true});
                        break;
                }
                switch (q.login) {
                    case "2":
                        window.analytics.event("sign_up", {method: "bizid"});
                        break;
                }
                window.history.replaceState({}, document.title, location.pathname);
            },
        };
    </script>
</index-tag>
